import { circularFontFamily } from '@airwallex/global';
import './components/timeline/index.js';
import { getTypographyTheme } from './components/typography/index.js';

// language/character-specific bits
var getLocalizedToken = param => {
  var {
    theme,
    fontFamily = circularFontFamily
  } = param;
  // TODO: add zh preference
  return {
    fontFamily: {
      default: fontFamily
    },
    typography: getTypographyTheme(theme, fontFamily)
  };
}; // if/when we introduce other languages with latin-like characters, they'd likely look like:
// export const fr = en;
// export const it = en;
// jp may reuse zh, as the characters have similar visual complexity
// export const jp = zh;
// arabic would likely have its own typography/theme
// export const ar: LocalizedTheme = {...}

export { getLocalizedToken };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxpemVkLmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9
